@if ((footernode$ | async); as footernodes) {
  <div class="footer_container">
    <div class="container-fluid">
      <div class="row">
        @for (node of footernodes.children; track node) {
          @if (node.title == 'Footer Logo') {
            <div class="col-md-4 footerlogomobile">
              <div class="footer-logo">
                @if ((logoData | async); as data) {
                  <div class="logo_seqirus">
                    <img [src]='getImage(data.media)' alt="seqirus">
                  </div>
                }
                @if ((visitsite | async); as site) {
                  <div class="fotter_txt" [innerHTML]="site.content"></div>
                }
              </div>
              @if ((ukFooterData | async); as ukData) {
                <div class="footertermsheaderuk">{{ukData.heading1}}</div>
                <p class="footerpara-1 footermar">{{ukData.text1}}</p>
                <div class="footertermsheaderuk">{{ukData.heading2}}</div>
                <div class="footerpara-1" [innerHTML]="ukData.text2"></div>
                <div class="footertermsheaderuk">{{ukData.heading3}}</div>
                <div class="footerpara-1" [innerHTML]="ukData.text3"></div>
              }
            </div>
          }
          @if ((currentSite == 'seqirusb2b-uk' && node.title === 'Navigate') || ((!isLoggedIn || (isLoggedIn && !userInfo?.webEnabled)) && node.title === 'Navigate')) {
            <div class="mob-footer-md-3" [ngClass]="{'uk_loggedout': currentSite == 'seqirusb2b-uk' && !isLoggedIn}">
              <div class="footerNavPart" [ngClass]="currentSite == 'seqirusb2b-uk'? 'footer_headinguk' : 'footer_heading'">{{node.title}}</div>
              <ul class="footerNavPart navigate_menu footer_menu_list_nav" [ngClass]="currentSite == 'seqirusb2b-uk'? 'footer_menu_listuk' : 'footer_menu_list'">
                @for (child of node.children; track child) {
                  @if (child.title != 'Returns' && child.title != 'Cookie Policy' && child.title !='Products') {
                    <li><a (click)="handleLinks(child.url, '')" target="_blank">{{child.title}}</a></li>
                  }
                  @if (child.title === 'Products' && currentSite == 'seqirusb2b-flu360') {
                    <li><a (click)="handleLinks(child.url, '')" target="_blank">{{child.title}}</a></li>
                  }
                  @if (child.title === 'Products' && currentSite == 'seqirusb2b-uk' && !isLoggedIn) {
                    <li><a (click)="handleLinks(child.url, '')" target="_blank">{{child.title}}</a></li>
                  }
                  @if (child.title === 'Products' && currentSite == 'seqirusb2b-uk' && isLoggedIn && !userInfo?.webEnabled) {
                    <li><a (click)="handleLinks(child.url, '')" target="_blank">{{child.title}}</a></li>
                  }
                  @if (child.title === 'Cookie Policy') {
                    <li><a (click)="gocookies(child.url)" target="_blank">{{child.title}}</a></li>
                  }
                  @if (child.title === 'Returns') {
                    <li><a [routerLink]="child.url" id="return_links">{{child.title}}</a></li>
                  }
                }
              </ul>
            </div>
          } @else {
            @if (node.title === 'Navigate') {
              <div class="mob-footer-md-3"></div>
            }
          }
          @if (node.title === 'Website Terms of Use' && currentSite=='seqirusb2b-flu360') {
            <div class="mob-footer-md-5 padding-L10">
              <div class="footer_heading">{{node.title}}</div>
              <ul class="footer_menu_list">
                @for (child of termsnConditionNodes; track child) {
                  @if (child.title == 'Terms and Conditions of Returnability') {
                    <li><a [routerLink]="child.url" target="_blank" >{{child.title}}</a></li>
                  }
                  @if (child.title == 'Terms and Conditions of Privacy') {
                    <li><a href="{{child.url}}" target="_blank" >{{child.title}}</a></li>
                  }
                  @if (child.title != 'Terms and Conditions of Privacy' && child.title != 'Terms and Conditions of Returnability') {
                    <li><a href="{{child.url}}" target="_blank" >{{child.title}}</a></li>
                  }
                }
              </ul>
            </div>
          }
          @if (node.title === 'Website Terms of Use' && currentSite=='seqirusb2b-uk') {
            <div class="col-md-3 col-xs-12 marTop-30">
              <div class="footer_headinguk">{{node.title}}</div>
              <ul class="footer_menu_listuk">
                @for (child of node.children; track child) {
                  @if (child.title != 'Privacy Policy') {
                    <li><a [routerLink]="child.url" target="_blank">{{child.title}}</a></li>
                  }
                  @if (child.title === 'Privacy Policy') {
                    <li><a [href]="child.url" target="_blank">{{child.title}}</a></li>
                  }
                }
              </ul>
            </div>
          }
        }
        @if ((ukFooterData |async); as ukData) {
          <div class="col-md-8 footer_parawidth">
            <div class="footer_paraheadinguk">{{ukData.heading4}}</div>
            <p class="footerpara-2" [innerHTML]="ukData.text4"></p>
            <!-- <p class="footerpara-3">
            In the case of a product complaint, please notify the CSL Seqirus customer services team on <a href="tel:0845 745 1500" class="footeritem2 doNotShowleavePopUp">0845 745 1500</a> or <a href="mailto:ukptc@seqirus.com" class="footerredlink3 doNotShowleavePopUp">ukptc@seqirus.com</a>
          and provide a full description of the nature of the complaint, contact details for complaint follow-up, and the batch number(s) of the vaccine(s) concerned.</p> -->
        </div>
      }
    </div>
    <div class="row">
      <div class="mob-footer-md-12">
        <div class="logoformobile margin-T20 margin-B20">
          @if ((logoData | async); as data) {
            <div class="logo_seqirus">
              <img [src]='getImage(data.media)' alt="seqirus">
            </div>
          }
          @if ((visitsite | async); as site) {
            <div class="fotter_txt" [innerHTML]="site.content"></div>
          }
        </div>
      </div>
    </div>
    <div class="row">
      @if (currentSite == 'seqirusb2b-flu360') {
        @if ((footerPara | async); as para) {
          <div class="mob-footer-md-12 footer_txt_disclaimer">
            <div class ="content" [innerHTML]="para.content"></div>
          </div>
        }
      } @else {
        @if ((ukFooterData | async); as ukData) {
          <div class="col-md-12 footer_txt_disclaimeruk">
            <p class="footer_copynote">{{ukData.trademarkText}}</p>
          </div>
        }
      }
    </div>
    <div class="row">
      <div class="mob-footer-md-12 fotter_bottom_logo">
      </div>
    </div>
  </div>
</div>
}
<div class="footer_commonleaving_abandonedPop modal" role="dialog"  data-bs-backdrop="static" [ngClass]="{'show': isModalOpen}"  id="footer_commonleaving_abandonedPop">
  <div class="knowledgeHub_abandonedPopContent">
    <div class="knowledgeHub_abandonedPopHeader">
      <div class="knowledgeHub_abandonedPopTitle">{{popupdata?.headline}}</div>
      <div class="knowledgeHub_abandonedPopClose"(click)="closeModal()">X</div>
      <div class="clearboth"></div>
    </div>
    <div class="knowledgeHub_abandonedPopText">
      <p [innerHTML]="popupdata?.message1" class="popup_Text1"></p>
      <p [innerHTML]="popupdata?.message2" class="popup_Text1"></p>
    </div>
    <div class="knowledgeHub_abandonedPopBtns">
      <button class="knowledgeHub_abandonedPopBtn commonleave_popContBtn" (click)="openUrl(popupdata?.link)">{{popupdata?.label1}}</button>
      <button
      class="knowledgeHub_abandonedPopBtn knowledgeHub_popCanceltBtn"(click)="closeModal()">{{popupdata?.label2}}</button>
    </div>
    <div class="knowledgedocnumberUk">{{popupdata?.jobBagCode}}</div>
  </div>
</div>